<template>
  <div class="mt-3">
    <div class="onboarding-flex">
      <div>
        <transition name="fade" mode="out-in">
          <BouncingLoader v-if="!hideMessage" />
          <IconCheck height="40" class="active" v-else />
        </transition>
        <h1 class="h3 mb-4 mt-4">
          <transition name="fade" mode="out-in">
            <span v-if="!hideMessage">Relax, we're talking to your store!</span>
            <span v-else>Success! Taking you to the setup wizard...</span>
          </transition>
        </h1>
        <p class="lead font-weight-normal text-muted">
          <transition name="fade" mode="out-in" v-if="!hideMessage">
            <span v-for="(message, index) in messages" :key="message" v-if="index === currentIndex">{{index + 1}} of {{messages.length}}: {{message}}</span>
          </transition>
          <span v-else></span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { random } from 'lodash-es'
import { mapState, mapActions } from 'vuex'
import { captureException } from '@sentry/browser'

import BouncingLoader from '@/components/BouncingLoader'

export default {
  data: function () {
    return {
      currentIndex: -1,
      redirectTo: null
    }
  },
  components: {
    BouncingLoader
  },
  computed: {
    ...mapState([ 'shopObj', 'plan', 'theme' ]),
    messages: function () {
      return [
        'Checking your Shopify theme',
        'Looking for reviews',
        'Gathering analytics settings',
        'Preparing the setup wizard'
      ]
    },
    path: function () {
      return this.$route.path
    },
    delay: function () {
      if (this.redirectTo === 'home') {
        return 1
      }

      return random(3500, 4500)
    },
    hideMessage: function () {
      return this.currentIndex >= this.messages.length
    }
  },
  mounted: async function () {
    this.init()
  },
  beforeDestroy: function () {
    clearTimeout(this.timeout)
  },
  methods: {
    ...mapActions([ 'getStatus', 'getClient' ]),
    init: async function () {
      if (this.hideMessage && this.redirectTo) {
        this.$router.replace({ name: this.redirectTo })
        return
      }

      if (!this.hideMessage) {
        this.currentIndex++
      }

      if (!this.redirectTo) {
        try {
          await this.check()
        } catch (e) {
          captureException(e)
          return
        }
      }

      this.timeout = setTimeout(this.init, this.delay)
    },
    check: async function () {
      const { setup, detect } = await this.getStatus()

      if (setup) {
        this.currentIndex = this.messages.length
        this.redirectTo = 'home'
      }

      if (!setup && detect) {
        this.redirectTo = 'setup_welcome'
      }

      if (this.redirectTo) {
        await this.getClient()
      }
    }
  }
}
</script>
